import moment from "moment";
import { useClock } from "../clock-store";
import { FC } from "react";
import { Typography } from "@mui/material";

const formatDuration = (d: moment.Duration): string => {
    const nbsp = "\u00A0";
    const days = Math.floor(d.asDays());
    const f = [
        days > 0 ? `${days}${nbsp}days, ` : undefined,
        `${d.hours()}:`,
        `${String(d.minutes()).padStart(2, "0")}:`,
        `${String(d.seconds()).padStart(2, "0")}`,
    ].join("");

    return f;
}

const ElapsedTime: FC<{ startDate: string | Date }> = (props) => {
    const clockNow = useClock();

    const then = moment(props.startDate);
    //let now = moment();
    const now = moment(clockNow);
    const d = moment.duration(now.diff(then));

    const isOver90Minutes = d.asMinutes() > 90;

    const elapsed = formatDuration(d);
    const style = isOver90Minutes ? { color: "red" } : {};

    return (
        <Typography variant="body2" style={style}>
            {elapsed}
        </Typography>
    )
}

export default ElapsedTime